import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { CardDetailsHeader } from './components/CardDetailsHeader';
import { CardDetailsContent } from './components/CardDetailsContent';
import { CardDetailsMap } from './components/CardDetailsMap';
import { CardDetailsHost } from './components/CardDetailsHost';
import { EventInclusions } from './components/EventInclusions';
import { EventExclusions } from './components/EventExclusions';
import { BASE_URL } from '../../config/config';
import { useAuth } from '../../context/AuthContext';

export const CardDetails = () => {
  const { id: eventId } = useParams();
  const { user } = useAuth();
  const userId = user?.result?._id ; // Fallback to provided test ID if not logged in
  
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/events/view-event-for-users?eventId=${eventId}&userId=${userId}`);
        const data = await response.json();
        
        if (data.result) {
          setEvent(data.result);
        } else {
          setError(data.message || 'Failed to fetch event details');
        }
      } catch (err) {
        console.error('Error fetching event details:', err);
        setError('An error occurred while fetching event details');
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventDetails();
    }
  }, [eventId, userId]);

  useEffect(() => {
    // Re-initialize Webflow IX2 after component mount or data change
    const initWebflow = () => {
      if (window.Webflow) {
        window.Webflow.destroy();
        window.Webflow.ready();
        window.Webflow.require('ix2').init();
      }
    };

    // Small delay to ensure React has finished rendering
    const timer = setTimeout(initWebflow, 500);
    return () => clearTimeout(timer);
  }, [event]);

  if (loading) {
    return (
      <div className="organizer-profile-wrapper">
             <Navbar dark={false} />
             <div className="loading-container">
               <div className="organizer-loader"></div>
               <p>Loading Event Details...</p>
             </div>
           </div>
    );
  }

  if (error) {
    return (
      <div className="bg min-h-screen flex items-center justify-center">
        <div className="text-white text-xl">Error: {error}</div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="bg min-h-screen flex items-center justify-center">
        <div className="text-white text-xl">Event not found</div>
      </div>
    );
  }

  return (
    <div className="bg">
      <section className="hero-bg-listing-creative">
        <Navbar dark={true} />
        <div className="hero">
          <div className="hero-container"></div>
        </div>
        <section className="listing-wrapper">
          <CardDetailsHeader event={event} />
          <CardDetailsContent event={event} userId={userId} />
          <EventInclusions inclusions={event?.inclusions} />
          <EventExclusions exclusions={event?.exclusions} />
          <CardDetailsMap event={event} />
          <CardDetailsHost event={event} />
        </section>
      </section>
      <Footer />
    </div>
  );
};
